<template>
  <div id="menuSetting">
    <div id="search" class="filter-container">
      <el-input v-model="listQuery.menuName" clearable :placeholder="$t('adminView.MenuName')" class="input-with-select"
        @clear="searchTable">
        <el-button slot="append" icon="el-icon-search" @click="searchTable" />
      </el-input>
      <el-button class="filter-item" type="primary" icon="el-icon-plus" style="margin: -2px 0 0 0;" @click="add(0)" />
      <el-button class="filter-item" type="primary" icon="el-icon-delete" style="margin:-2px 0 0 0;"
        @click="deleteItems" />
    </div>

    <div>
      <el-table v-loading.body="listLoading" :data="list" element-loading-text="Loading" border fit
        highlight-current-row @selection-change="selectChange">
        <el-table-column type="selection" align="center" width="95" />
        <el-table-column :label="$t('adminView.MenuName')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.menuName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('adminView.Sort')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.menuLevel }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('adminView.MenuID')" align="center">
          <template slot-scope="scope">
            {{ scope.row.menuCode }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('adminView.MenuSubID')" align="center">
          <template slot-scope="scope">
            {{ scope.row.menuLongCode }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('adminView.MenuPath')" align="center">
          <template slot-scope="scope">
            {{ scope.row.menuUrl }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('adminView.MenuType')" align="center">
          <template slot-scope="scope">
            {{ scope.row.menuType }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('yhubReport.Operating')">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="mini" @click="edit(scope.row)" icon="el-icon-edit-outline"></el-button> -->
            <el-button type="text" size="mini" @click="add(scope.row.id)">{{ $t('adminView.AddNextMenu') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination v-if="pageshow" background current-page.sync="listQuery.pageInfo.page"
            :page-sizes="listQuery.pageInfo.pageList" :page-size="listQuery.pageInfo.limit"
            layout="total, sizes, prev, pager, next, jumper" :total="listQuery.pageInfo.total"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
      <div>
        <el-dialog :close-on-click-modal="false" :title="dialogStatus" :visible.sync="dialogFormVisible">
          <el-form ref="dataForm" :rules="rules" :model="menuModel" label-position="left" label-width="100px"
            style="width: 400px; margin-left:50px;">
            <el-form-item hidden="true">
              <el-input v-model="menuModel.menuParentId" />
            </el-form-item>
            <el-form-item :label="$t('adminView.MenuName')" prop="menuName">
              <el-input v-model="menuModel.menuName" />
            </el-form-item>
            <el-form-item :label="$t('adminView.MenuPath')" prop="menuUrl">
              <el-input v-model="menuModel.menuUrl" />
            </el-form-item>
            <el-form-item :label="$t('adminView.MenuType')" prop="menuType">
              <el-select v-model="menuModel.menuType" class="filter-item" :placeholder="$t('button.select')">
                <el-option v-for="item in menuType" :key="item.itemCode" :label="item.itemValue"
                  :value="item.itemCode" />
              </el-select>
            </el-form-item>
            <el-form-item label="菜单icon">
              <el-input v-model="menuModel.menuIcon" />
            </el-form-item>
            <el-form-item label="排序">
              <el-input v-model="menuModel.menuLevel" />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">{{ $t('button.Cancel') }}</el-button>
            <el-button type="primary" @click="submitPop">{{ $t('button.Submit') }}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { pageList, insert, deleteById, deleteByIds } from '@/api/roleAndMenu'
import { pagination } from '@/utils/init_table'
import i18n from '@/i18n'

var menuType = [
  { itemCode: '1', itemValue: i18n.t('adminView.MenuNoNavigation') },
  { itemCode: '2', itemValue: i18n.t('adminView.MenuNavigation') }
  // { itemCode: '3', itemValue: '按钮' }
]

export default {
  filters: {
    statusFilter (status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  data () {
    return {
      list: null,
      listLoading: true,
      // 分页----start
      listQuery: {
        menuName: null,
        pageInfo: pagination()
      },
      pageshow: true,
      // 分页----end
      dialogStatus: '',
      menuType,
      menuModel: {
        menuName: null,
        menuUrl: null,
        menuCode: null,
        menuParentId: null,
        menuIcon: null,
        menuRedirect: null,
        id: null,
        menuLevel: ''
      },
      textMap: {
        update: 'Edit',
        create: 'Create'
      },
      rules: {
        menuName: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        menuUrl: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        menuType: [{ required: true, message: i18n.t('lease.Cannotbeblanked2') }]
      },
      dialogFormVisible: false,
      itemIds: null
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    }
  },
  watch: {
    language (newValue, oldValue) {
      menuType[0].itemValue = i18n.t('adminView.MenuNoNavigation')
      menuType[1].itemValue = i18n.t('adminView.MenuNavigation')
      this.rules.menuName[0].message = this.rules.menuUrl[0].message = this.rules.menuType[0].message = i18n.t('lease.Cannotbeblanked2')
    }
  },
  created () {
    this.queryList()
  },
  methods: {
    edit (row) {
      this.menuModel = JSON.parse(JSON.stringify(row))
      this.dialogFormVisible = true
    },
    queryList () {
      this.listLoading = true
      var param = {
        'menuName': this.listQuery.menuName,
        'pageNum': this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        'pageSize': this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      pageList(param).then(response => {
        this.list = response.resultModel.list
        this.listQuery.pageInfo.total = response.resultModel.total // 分页
        this.listLoading = false
      })
    },
    searchTable () {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    add (menuParentId) {
      this.resetTemp()
      if (menuParentId) {
        this.menuModel.menuParentId = menuParentId
      }
      this.dialogStatus = i18n.t('adminView.add')
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    resetTemp () {
      for (var key in this.menuModel) {
        this.menuModel[key] = null
      }
    },
    submitPop () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          insert(this.menuModel).then(response => {
            if (response.resultCode == 1001) {
              this.dialogFormVisible = false
              this.queryList()
              this.$notify({
                title: '',
                message: i18n.t('lease.Succeed'),
                type: 'success',
                duration: 2000
              })
            }
          })
        }
      })
    },
    handleUpdate (row) {
      this.dialogStatus = i18n.t('adminView.Edit')
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    // 分页----start
    handleSizeChange (val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    // 分页----end
    selectChange (selection) {
      this.itemIds = selection
    },
    deleteItems () {
      if (!this.itemIds || this.itemIds.length === 0) {
        this.$message({
          type: 'info',
          message: i18n.t('adminView.SelectRecords')// '请选择需要删除的记录'
        })
        return
      }
      this.$confirm(i18n.t('adminView.ConfirmDelete'), '', {// '此操作将永久删除该记录, 是否继续?'
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        if (this.itemIds) {
          var ids = []
          for (var itemKey in this.itemIds) {
            ids.push(this.itemIds[itemKey].id)
          }
          if (ids.length == 1) {
            deleteById({ 'id': ids[0] }).then(response => {
              if (response.resultCode === 1001) {
                this.itemIds = null
                this.queryList()
                this.$notify({
                  title: '',
                  message: i18n.t('lease.Succeed'),
                  type: 'success',
                  duration: 2000
                })
              }
            })
          } else {
            deleteByIds({ 'ids': ids }).then(response => {
              if (response.resultCode === 1001) {
                this.itemIds = null
                this.queryList()
                this.$notify({
                  title: '',
                  message: i18n.t('lease.Succeed'),
                  type: 'success',
                  duration: 2000
                })
              }
            })
          }
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: i18n.t('adminView.Canceled')// '已取消删除'
        })
      })
    }
  }
}
</script>
<style lang="scss">
#menuSetting {
  background: #fff;
  padding: 13px 20px;
  #search .el-input-group {
    width: 40% !important;
    max-width: 300px !important;
    // margin-top: 13px;
  }
}
</style>
